import { APIResource } from 'services'
export const Rates = new APIResource(
  '/rates.json',
  {
    index:   endpoint => endpoint.headers(headers => headers['Content-Type'] = undefined)
  },
  {
    apiBase: "https://api.bravenewcoin.com"
  }
)